import React from "react";

export default class EuiRow extends React.Component {

    render() {
        return <div className={"row " + (this.props.disabled ?? "") + " " + (this.props.className ?? "")} style={{ ...this.props.style }}>{this.props.children}</div>;
  }
}
